module.exports = __webpack_public_path__ + "static/media/7.7ae53b7f.jpg";